// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Row$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Row.bs.js";
import * as Column$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Column.bs.js";
import * as FormInput$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormInput.bs.js";
import * as FormHelper$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/FormHelper.bs.js";
import * as FormTextInput$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormTextInput.bs.js";

function OrderAndPartnerIDFormCmp(Props) {
  var form = Props.form;
  var resetPenaltyList = Props.resetPenaltyList;
  return React.createElement(Row$Catalyst.make, {
              children: null
            }, React.createElement(Column$Catalyst.make, {
                  children: null,
                  className: "input-text-wrapper"
                }, React.createElement("label", {
                      className: "label"
                    }, "Order ID:"), React.createElement(FormTextInput$Catalyst.make, {
                      input_props: FormInput$Catalyst.make_props("", undefined, undefined, undefined, "Enter Order ID", undefined, undefined, undefined, form.crnResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                      textinput_props: {
                        value: form.input.crn
                      }
                    })), React.createElement(Column$Catalyst.make, {
                  children: null,
                  className: "input-text-wrapper"
                }, React.createElement("label", {
                      className: "label"
                    }, "Partner MSISDN:"), React.createElement(FormTextInput$Catalyst.make, {
                      input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                              Curry._1(resetPenaltyList, undefined);
                              return Curry._2(form.updateMsisdn, (function (input, value) {
                                            return {
                                                    crn: input.crn,
                                                    msisdn: value,
                                                    penalty_type: input.penalty_type
                                                  };
                                          }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                            }), undefined, undefined, "Driver MSISDN", undefined, undefined, undefined, form.msisdnResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                      textinput_props: {
                        value: form.input.msisdn
                      }
                    })));
}

var make = OrderAndPartnerIDFormCmp;

export {
  make ,
  
}
/* react Not a pure module */
